import { h } from "preact";

import OnboardingGuidanceActions from "../../apps/data/onboarding/OnboardingGuidanceActions";
import { GuidanceDismissType, GuidanceEvent } from "../../apps/data/onboarding/types";
import Link from "../../foundation/router/Link";
import classname from "../../foundation/utils/classname";
import { imageUrl } from "../../foundation/utils/image";
import IconArrowLeft from "../Icons/IconArrowLeft";

import Chip, { ChipBackground } from "../v2/Chip";

import LoadingBar from "./LoadingBar";

import styles from "./Header.module.css";

interface Props {
    headerLeft?: JSX.Element;
    headerCenter?: JSX.Element;
    headerRight?: JSX.Element;
    homeURL?: string;
    backButtonLabel: string | JSX.Element | null;
    backButtonLink: string | null;
    backButtonInfo?: JSX.Element;
    backButtonHasOffset?: boolean;
    isOrganizationBarrel?: boolean;
    hideLogo?: boolean;
    tall?: boolean;
    hidden?: boolean;
    loading?: boolean;
    class?: string;
    shouldDisplayFrozenLabel?: boolean;
    onDoubleClick?: (ev: MouseEvent) => void;
}

function Header({
    headerLeft,
    headerCenter,
    headerRight,
    backButtonInfo,
    homeURL,
    backButtonLabel,
    backButtonLink,
    backButtonHasOffset,
    isOrganizationBarrel,
    hideLogo,
    tall,
    hidden,
    loading,
    class: cssClass,
    shouldDisplayFrozenLabel,
    onDoubleClick
}: Props) {
    function onClickBackButton() {
        if (isOrganizationBarrel && backButtonLabel) {
            OnboardingGuidanceActions.dismissOnboardingGuidanceTooltip({
                eventName: GuidanceEvent.ViewOrganizationWorkspace,
                dismissType: GuidanceDismissType.ClickedToAction
            });
        }
    }

    return (
        <header class={classname(cssClass, { [styles.tall]: tall, hidden })} onDblClick={onDoubleClick}>
            <div class={classname(styles.headerLeft, "noSelect")}>
                {!hideLogo && (
                    <Link class={styles.homeLink} to={homeURL ?? "/"} back="">
                        <img
                            width="36"
                            height="29"
                            src={imageUrl("img/icZeplin.svg")} alt="Zeplin"
                            class={styles.logo}/>
                    </Link>
                )}
                {shouldDisplayFrozenLabel && <Chip text="Frozen" background={ChipBackground.Blue}/>}
                {backButtonLabel && (
                    <div>
                        <Link
                            class={classname(styles.backLink, "ellipsis", { [styles.hasOffset]: backButtonHasOffset })}
                            to={backButtonLink!}
                            back=""
                            onClick={onClickBackButton}>
                            <IconArrowLeft color="var(--gandalf)"/>
                            <span>{backButtonLabel}</span>
                        </Link>
                        {backButtonInfo}
                    </div>
                )}
                {headerLeft}
            </div>
            <div class={classname(styles.headerCenter, "noSelect")}>{headerCenter}</div>
            <div class={classname(styles.headerRight, "noSelect")}>{headerRight}</div>
            <LoadingBar running={loading}/>
        </header>
    );
}

Header.defaultProps = {
    homeURL: "/"
};

export default Header;
